import axios, { type AxiosInstance } from 'axios'
import { useAuth } from '~/composables/useAuth'
import { sanitizeApiPayload, normalizeBaseUrl } from '~/utils/helpers'

/**
 * Instance Axios vers Prepeers.FrontApi (base publique, en-tête X-Api-Key, Bearer MSAL).
 * @returns {AxiosInstance} Instance prête pour les appels HTTP vers FrontApi.
 */
export function useFrontApi(): AxiosInstance {
  const config = useRuntimeConfig()
  const { getApiToken } = useAuth()

  const instance = axios.create({
    baseURL: normalizeBaseUrl(config.public.frontApiBaseUrl as string),
    headers: { 'X-Api-Key': config.public.frontXApiKey as string },
  })

  instance.interceptors.request.use(async (req) => {
    // Un jeton déjà posé par l'appelant est conservé (création du profil juste après la connexion Entra).
    if (import.meta.client && !req.headers.Authorization) {
      const token = await getApiToken()
      if (token) req.headers.Authorization = `Bearer ${token}`
    }
    return req
  })

  instance.interceptors.response.use((response) => {
    const { data } = response
    if (
      data !== null &&
      typeof data === 'object' &&
      !(data instanceof ArrayBuffer) &&
      !(data instanceof Blob)
    ) {
      response.data = sanitizeApiPayload(data)
    }
    return response
  })

  return instance
}
